import * as yup from 'yup';

import { validate } from '../../../../shared/utils/validation.utils';
import {
    companyNameSchema,
    companySectorSchema,
    companySizeSchema,
    employeePositionSchema,
    fullNameSchema,
    phoneSchema,
} from '../../auth.validation';
import { CompanySignUpData, UserProfileSignUpData } from '../sign-up-data.types';

const userProfileSchema = yup
    .object()
    .shape({
        fullName: fullNameSchema,
        phone: phoneSchema,
    });

const companySchema = yup
    .object()
    .shape({
        companyName: companyNameSchema,
        role: employeePositionSchema,
        section: companySectorSchema,
        companySize: companySizeSchema,
    });

export const validateUserProfile = (userProfile: UserProfileSignUpData) => validate(
    userProfileSchema,
    userProfile,
    {
        convert: true,
        abortEarly: false,
    },
);

export const validateCompany = (company: CompanySignUpData) => validate(
    companySchema,
    company,
    {
        convert: true,
        abortEarly: false,
    },
);
